/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Error_Invalid_PhotoInputs */

const en_directory_ai_tools_error_invalid_photo = /** @type {(inputs: Directory_Ai_Tools_Error_Invalid_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-upload both photos and try again.`)
};

const zh_directory_ai_tools_error_invalid_photo = /** @type {(inputs: Directory_Ai_Tools_Error_Invalid_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请重新上传两张照片后再试。`)
};

/**
* | output |
* | --- |
* | "Re-upload both photos and try again." |
*
* @param {Directory_Ai_Tools_Error_Invalid_PhotoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_error_invalid_photo = /** @type {((inputs?: Directory_Ai_Tools_Error_Invalid_PhotoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Error_Invalid_PhotoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_error_invalid_photo(inputs)
	return zh_directory_ai_tools_error_invalid_photo(inputs)
});
export { directory_ai_tools_error_invalid_photo as "directory.ai_tools.error.invalid_photo" }